import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";

const WpdsContext = createContext({
  Popover: null
});

export const useWpdsContext = () => useContext(WpdsContext);

export const WpdsProvider = ({ children, Popover = null }) => {
  const contextValue = useMemo(
    () => ({
      Popover
    }),
    [Popover]
  );

  return (
    <WpdsContext.Provider value={contextValue}>{children}</WpdsContext.Provider>
  );
};

WpdsProvider.propTypes = {
  Popover: PropTypes.object,
  children: PropTypes.node,
  styled: PropTypes.func
};
